<template>
  <div class="">
    
    <div class="row">
      <div class="col-12 mb-2">
        <button @click="refresh()" class="btn ms-auto btn0 btn-secondary">
          <i class="bi bi-arrow-clockwise"></i>
        </button>
      </div>
    </div>

    <div class="row align-items-stratch">
     

      <div class="col-12 col-xl-12 p-2">
        <div class="bg-white rounded border h-100 p-3">
          <div class="row align-items-center">
            <div class="col">
              <div class="row align-items-center">
                <div class="col"></div>
              </div>
            </div>

            <div class="col">
              <div class="row align-items-center">
                <div class="col">Total</div>
              </div>
            </div>

            <div class="col">
              <div class="row align-items-center">
                <div class="col">Payé</div>
              </div>
            </div>

            <div class="col">
              <div>Impayé</div>
            </div>

            <div class="col">
              <div class="row align-items-center">
                <div class="col">Règlement</div>
              </div>
            </div>
          </div>
          <hr />
          <div class="row align-items-center">
            <div class="col">
              <div class="row align-items-center">
                <div class="col">
                  {{ $t("dashboard10") }}
                </div>
              </div>
            </div>

            <div class="col">
              <div class="row align-items-center">
                <div class="col-auto">
                  <span class="fw-bold text-info"> 0.00 </span>
                </div>
              </div>
            </div>

            <div class="col">
              <div class="row align-items-center">
                <div class="col-auto">
                  <span class="fw-bold text-success"> + 0.00 </span>
                </div>
              </div>
            </div>

            <div class="col">
              <div class="row align-items-center">
                <div class="col-auto">
                  <span class="fw-bold text-danger"> - 0.00 </span>
                </div>
              </div>
            </div>

            <div class="col">
              <div class="row align-items-center">
                <div class="col-auto">
                  <span class="fw-bold text-warning"> + 0.00 </span>
                </div>
              </div>
            </div>
          </div>
          <br />

          <div class="row align-items-center">
            <div class="col">
              <div class="row align-items-center">
                <div class="col">
                  {{ $t("dashboard11") }}
                </div>
              </div>
            </div>

            <div class="col">
              <div class="row align-items-center">
                <div class="col-auto">
                  <span class="fw-bold text-info"> 0.00 </span>
                </div>
              </div>
            </div>

            <div class="col">
              <div class="row align-items-center">
                <div class="col-auto">
                  <span class="fw-bold text-success"> + 0.00 </span>
                </div>
              </div>
            </div>

            <div class="col">
              <div class="row align-items-center">
                <div class="col-auto">
                  <span class="fw-bold text-danger"> - 0.00 </span>
                </div>
              </div>
            </div>

            <div class="col">
              <div class="row align-items-center">
                <div class="col-auto">
                  <span class="fw-bold text-warning"> + 0.00 </span>
                </div>
              </div>
            </div>
          </div>
          <br />

          <div class="row align-items-center">
            <div class="col">
              <div class="row align-items-center">
                <div class="col">
                  {{ $t("dashboard12") }}
                </div>
              </div>
            </div>

            <div class="col">
              <div class="row align-items-center">
                <div class="col-auto">
                  <span class="fw-bold text-info"> 0.00 </span>
                </div>
              </div>
            </div>

            <div class="col">
              <div class="row align-items-center">
                <div class="col-auto">
                  <span class="fw-bold text-success"> + 0.00 </span>
                </div>
              </div>
            </div>

            <div class="col">
              <div class="row align-items-center">
                <div class="col-auto">
                  <span class="fw-bold text-danger"> - 0.00 </span>
                </div>
              </div>
            </div>

            <div class="col">
              <div class="row align-items-center">
                <div class="col-auto">
                  <span class="fw-bold text-warning"> + 0.00 </span>
                </div>
              </div>
            </div>
          </div>

          <br />
          <div class="row align-items-center">
            <div class="col">
              <div class="row align-items-center">
                <div class="col">
                  {{ $t("dashboard13") }}
                </div>
              </div>
            </div>

            <div class="col">
              <div class="row align-items-center">
                <div class="col">
                  {{ $t("dashboard13") }}
                </div>
                <div class="col-auto">
                  <span class="fw-bold"> 0.00 </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="col-12 col-xl-6">
        <line-chart
          :chart-data="lineChartData"
          :options="lineChartOptions"
        ></line-chart>
      </div> -->

      <!-- <div class="col-4">
        <scatter-chart
          :chart-data="scatterData"
          :options="scatterOptions"
        ></scatter-chart>
      </div> -->
    </div>
    <br />
    <br />

    <div class="row p-1">
      <div class="bg-white rounded border p-3">
        <div class="row">
          <div class="col text-center text-secondary">
            {{ $t("dashboard14") }}
          </div>
        </div>
        <br />
        <div
          v-for="(quantity, index) in quantityAnalytics"
          :key="index++"
          class="row"
        >
          <div class="col">{{ quantityreference }} {{ quantity.fullName }}</div>
          <div class="col-2">
            <span class="text-success">
              + {{ quantity.purchasedQuantity }}
            </span>
          </div>
          <div class="col-2">
            <span class="text-danger"> - {{ quantity.soldQuantity }} </span>
          </div>
          <div class="col-2">
            <span class="text-primary">
              {{ quantity.stockQuantity }}
            </span>
          </div>
        </div>
      </div>
    </div>
    <br />

    <div class="row">
      <div class="col-xl-8 col-12"></div>
      <!-- <div class="col-xl-4 col-12">
        <div
          v-for="(user, index) in users"
          :key="index++"
          class="row d-flex border rounded align-items-center p-0 my-1"
        >
          <div class="col-auto m-0 p-0">
            <i
              class="bi bi-person-exclamation"
              :style="{
                fontSize: '27px !important',
              }"
            ></i>
          </div>
          <div class="col-6 m-0 p-0">
            <span v-if="user.employee">
              {{ user.employee.fullName }}
            </span>
          </div>
          <div class="col m-0 p-0">
            <span
              class="p-0 m-0"
              :style="{
                fontSize: '40px !important',
                fontWeight: 'bolder !important',
              }"
              :class="
                user.last_seen_minutes_ago < 30 &&
                user.last_seen_seconds_ago != -1
                  ? 'text-success'
                  : 'text-secondary'
              "
            >
              .
            </span>
            <span
              v-if="user.last_seen_seconds_ago == -1"
              class="text-secondary"
            >
              Inactif
            </span>
            <span
              v-else-if="user.last_seen_seconds_ago == 0"
              class="text-success"
            >
              Actif
            </span>
            <span
              v-else-if="user.last_seen_seconds_ago < 60"
              class="text-warning"
            >
              - {{ user.last_seen_seconds_ago }} secondes
            </span>
            <span
              v-else-if="user.last_seen_minutes_ago < 60"
              :class="
                user.last_seen_minutes_ago < 30 ? 'text-success' : 'text-waning'
              "
            >
              - {{ user.last_seen_minutes_ago }} minutes
            </span>
            <span v-else-if="user.last_seen_hours_ago < 24" class="text-danger">
              -{{ user.last_seen_hours_ago }} heures
            </span>
            <span v-else class="text-danger">
              - {{ user.last_seen_days_ago }} jours
            </span>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

import moment from "moment";
export default {
  components: {
   
  },
  data() {
    return {
      scatterData: {
        datasets: [
          {
            label: "Scatter Data",
            data: [
              { x: 10, y: 20 },
              { x: 5, y: 25 },
              { x: 15, y: 10 },
              // Add more data points as needed
            ],
            backgroundColor: "rgba(75, 192, 192, 0.2)",
            borderColor: "rgba(75, 192, 192, 1)",
            borderWidth: 1,
            showLine: true,
          },
        ],
      },
      scatterOptions: {
        scales: {
          x: {
            type: "linear",
            position: "bottom",
          },
          y: {
            type: "linear",
            position: "left",
          },
        },
        // Add more chart options as needed
      },

      lineChartData: {
        labels: ["Total Ventes", "Payé", "Impayé", "Règlement "],
        datasets: [
          {
            label: "My Line Chart",
            data: [10, 20, 30, 25],
            backgroundColor: "rgba(75, 192, 192, 0.2)",
            borderColor: "rgba(75, 192, 192, 1)",
            borderWidth: 1,
          },
        ],
      },
      lineChartOptions: {
        scales: {
          y: {
            beginAtZero: true,
          },
        },
        height: 300,
      },
    };
  },
  computed: {
    ...mapGetters("statistic", {
      totalTodays: "getTotalTodays",
      // barTodaysChartData: "getBarTodaysChartData",
      quantityAnalytics: "getQuantityAnalytics",
    }),

    ...mapGetters("user", {
      users: "getAll",
      userOnline: "getUserOnline",
    }),
  },
  mounted() {
    this.$store.dispatch("statistic/fetchTotalTodays");
    this.$store.dispatch(
      "statistic/fetchQuantityAnalytics",
      moment(new Date()).format("YYYY-MM-DD")
    );
    this.$store.dispatch("user/getAll");
    this.$store.dispatch("user/fetchUserStatus");
  },
  methods: {
    refresh() {
      this.$store.dispatch("statistic/fetchTotalTodays");
    },
  },
};
</script>
